import styled from 'styled-components';

import { ActionButton } from 'components/action-button';

export const Wrapper = styled.div``;

export const ReorderButton = styled(ActionButton)`
  font-size: 1rem;
  padding: 0 16px;
  height: 32px;
`;
